import { render, staticRenderFns } from "./CardVaroitus.vue?vue&type=template&id=5894dbde&"
import script from "./CardVaroitus.vue?vue&type=script&lang=js&"
export * from "./CardVaroitus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5894dbde')) {
      api.createRecord('5894dbde', component.options)
    } else {
      api.reload('5894dbde', component.options)
    }
    module.hot.accept("./CardVaroitus.vue?vue&type=template&id=5894dbde&", function () {
      api.rerender('5894dbde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CardVaroitus.vue"
export default component.exports